export function changeAccordionFAQ() {
    const section = document.querySelector('.content-faq');
    if (!section) return;

    const accordions = section.querySelectorAll('.accordion-collapse');

    accordions.forEach(collapse => {
        const item = collapse.closest('.accordion-item');

        if (collapse.classList.contains('show')) {
            item.classList.add('active');
        }

        collapse.addEventListener('show.bs.collapse', function () {
            item.classList.add('active');
        });

        collapse.addEventListener('hide.bs.collapse', function () {
            item.classList.remove('active');
        });
    });
}
